import { Text } from '@fluentui/react';
import React, { Fragment } from 'react';

export const ErrorString = ({ error } : { error: string }) => (
  <Fragment>
    <Text
      className="error-string"
      variant="small"
      block
      nowrap
      styles={{ root: { color: '#A80000' } }}
      role="alert"
      aria-live="polite"
    >
      {error}
    </Text>
  </Fragment>
);

export const getDescription = (input, maxLength, i18n) => {
  if (input == null || input.length === 0) {
    return undefined;
  }
  const { length } = input;
  const diff = maxLength - length;
  if (diff >= 0) {
    return i18n.getString(_TL_('{{number}} characters remaining'), { number: diff });
  }
  return i18n.getString(_TL_('Exceeded by {{number}} characters'), { number: Math.abs(diff) });
};
